import { shrpaApi } from "./axios";
import { ContentSummaryFullPayload, ContentSummaryPreviewPayload, ContentSummaryStatusResults } from "@contracts/contentCalendar";

export default {
  async getAllSummariesFull(customerId: string, justValid = true): Promise<ContentSummaryFullPayload> {
    const uri = `/content-summary/${customerId}/full?justValid=${justValid}`;
    const { data } = await shrpaApi.get<ContentSummaryFullPayload>(uri);
    return data;
  },

  async getAllSummariesPreview(customerId: string, justValid = true, includeExamples = false): Promise<ContentSummaryPreviewPayload> {
    const uri = `/content-summary/${customerId}/preview?justValid=${justValid}&includeExamples=${includeExamples}`;
    const { data } = await shrpaApi.get<ContentSummaryPreviewPayload>(uri);
    return data;
  },

  async generateContentSummary(customerId: string): Promise<string> {
    const uri = `/content-summary-gen/${customerId}`;
    const { data } = await shrpaApi.put<string>(uri);
    return data;
  },

  async checkContentSummaryStatus(customerId: string): Promise<ContentSummaryStatusResults> {
    const uri = `/content-summary/${customerId}/check-status`;
    const { data } = await shrpaApi.get<ContentSummaryStatusResults>(uri);
    return data;
  },
};
